import { hypothesisMappers } from '../../external-imports'
import { GetProjectCaseResponse, ProjectCase } from '../types'

function mapProjectCase(response: Partial<GetProjectCaseResponse> = {}): ProjectCase {
  return {
    id: response.id ?? 0,
    user_id: response.user_id ?? 0,
    name: response.name ?? '',
    description: response.description ?? '',
    activity: response.activity ?? '',
    website: response.website ?? '',
    state_before: response.state_before ?? '',
    state_after: response.state_after ?? '',
    conversions: response.conversions ?? null,
    company_size_id: response.company_size_id ?? 0,
    bill_size_id: response.bill_size_id ?? 0,
    customer_goal_id: response.customer_goal_id ?? 0,
    customer_goal_name: response.customer_goal_name ?? '',
    customer_goal_code: response.customer_goal_code ?? null,
    customer_request_id: response.customer_request_id ?? 0,
    customer_request_name: response.customer_request_name ?? '',
    customer_request_code: response.customer_request_code ?? null,
    customer_problem_id: response.customer_problem_id ?? 0,
    customer_problem_name: response.customer_problem_name ?? '',
    customer_problem_code: response.customer_problem_code ?? null,
    company_size_name: response.company_size_name ?? '',
    bill_size_name: response.bill_size_name ?? '',
    average_bill_value: response.average_bill_value ?? '',
    employees_count: response.employees_count ?? '',
    product_type_id: response.product_type_id ?? 0,
    product_type_name: response.product_type_name ?? '',
    is_default: response.is_default ?? false,
    is_deleted: response.is_deleted ?? false,
    created: response.created ?? '',
    updated: response.updated ?? '',
    company_size: response.company_size ?? { id: 0, name: '' },
    bill_size: response.bill_size ?? { id: 0, name: '' },
    product_type: response.product_type ?? { id: 0, name: '' },
    request: response.request ?? { id: 0, name: '' },
    problem: response.problem ?? { id: 0, name: '' },
    goal: response.goal ?? { id: 0, name: '' },
    customer_goal: response.customer_goal ?? { id: 0, name: '' },
    customer_problem: response.customer_problem ?? { id: 0, name: '' },
    customer_request: response.customer_request ?? { id: 0, name: '' },
    growth_point: response.growth_point
      ? {
          id: response.growth_point.id ?? '',
          content: response.growth_point.content ?? '',
          tasks:
            response.growth_point.tasks?.map((task) => ({
              id: task.id ?? '',
              exoid: task.exoid ?? '',
              name: task.name ?? '',
              image: task.image ?? '',
              thumb: task.thumb ?? '',
              task_id: task.task_id ?? '',
              status: task.status ?? '0',
              conclusions: task.conclusions ?? '',
              hypotheses: task.hypotheses?.map((hypothesis) => hypothesisMappers.mapHypothesis(hypothesis)) ?? [],
            })) ?? [],
        }
      : { id: '', content: '', tasks: [] },
  }
}

const mappers = { mapProjectCase }

export default mappers
